import {Effect} from './effect.js';

export class ColorShiftEffect extends Effect{
  constructor(aGl){
    
    super(aGl);

    this.fragmentShader =
    `
        precision mediump float;
        // our texture
        uniform sampler2D u_image0;

        // the texCoords passed in from the vertex shader.
        varying vec2 v_texCoord;

        uniform float u_hShift;
        uniform float u_sShift;
        uniform float u_lShift;

        vec3 rgb2hsv(vec3 c)
        {
        // vec4 K = vec4(0.0, -1.0 / 3.0, 2.0 / 3.0, -1.0);
        // vec4 p = mix(vec4(c.bg, K.wz), vec4(c.gb, K.xy), step(c.b, c.g));
        // vec4 q = mix(vec4(p.xyw, c.r), vec4(c.r, p.yzx), step(p.x, c.r));

        // float d = q.x - min(q.w, q.y);
        // float e = 1.0e-10;
        // return vec3(abs(q.z + (q.w - q.y) / (6.0 * d + e)), d / (q.x + e), q.x);
            
          float lmin = min(min(c.r, c.g), c.b);
          float lmax = max(max(c.r, c.g), c.b);
          float delta = lmax - lmin;
          vec3 hsl;

          if(lmax == lmin) {
            hsl.x = 0.0;
          }
          else if(c.r == lmax) {
            hsl.x = (c.g - c.b) / delta;
          }
          else if(c.g == lmax) {
            hsl.x = 2.0 + (c.b - c.r) / delta;
          }
          else if(c.b == lmax) {
            hsl.x = 4.0 + (c.r - c.g)/ delta;
          }

          hsl.x = min(hsl.x * 60.0, 360.0);

          if(hsl.x < 0.0) {
            hsl.x += 360.0;
          }

          hsl.z = (lmin + lmax) / 2.0;

          if(lmax == lmin) {
            hsl.y = 0.0;
          }
          else if(hsl.z <= 0.5) {
            hsl.y = delta / (lmax + lmin);
          }
          else {
            hsl.y = delta / (2.0 - lmax - lmin);
          }

          return vec3(hsl.x, hsl.y, hsl.z);
        }

        vec3 hsv2rgb(vec3 c)
        {
            // vec4 K = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);
            // vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);
            // return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);
          
          float h = c.x / 360.0;
          float s = c.y;
          float l = c.z;
          float t1, t2, t3, val;
          vec3 rgb = vec3(0.0, 0.0, 0.0);

          if(s == 0.0) {
            return vec3(val, val, val);
          }

          if(l < 0.5) {
            t2 = l * (1.0 + s);
          }
          else {
            t2 = l + s - l * s;
          }
          t1 = 2.0 * l - t2;

          t3 = h + 1.0 / 3.0;
          if( t3 < 0.0 ) { ++t3; }
          if( t3 > 1.0 ) { --t3; }
          if(6.0 * t3 < 1.0) {
            val = t1 + (t2 - t1) * 6.0 * t3;
          }
          else if(2.0 * t3 < 1.0) {
            val = t2;
          }
          else if(3.0 * t3 < 2.0) {
            val = t1 + (t2 - t1) * (2.0 / 3.0 - t3) * 6.0;
          }
          else {
            val = t1;
          }
          rgb.x = val;

          t3 = h;
          if( t3 < 0.0 ) { ++t3; }
          if( t3 > 1.0 ) { --t3; }
          if(6.0 * t3 < 1.0) {
            val = t1 + (t2 - t1) * 6.0 * t3;
          }
          else if(2.0 * t3 < 1.0) {
            val = t2;
          }
          else if(3.0 * t3 < 2.0) {
            val = t1 + (t2 - t1) * (2.0 / 3.0 - t3) * 6.0;
          }
          else {
            val = t1;
          }
          rgb.y = val;

          t3 = h - 1.0 / 3.0;
          if( t3 < 0.0 ) { ++t3; }
          if( t3 > 1.0 ) { --t3; }
          if(6.0 * t3 < 1.0) {
            val = t1 + (t2 - t1) * 6.0 * t3;
          }
          else if(2.0 * t3 < 1.0) {
            val = t2;
          }
          else if(3.0 * t3 < 2.0) {
            val = t1 + (t2 - t1) * (2.0 / 3.0 - t3) * 6.0;
          }
          else {
            val = t1;
          }
          rgb.z = val;

          return rgb;
        }

        void main() {
        // Look up a color from the texture.
        vec4 bg = texture2D(u_image0, v_texCoord);
        vec3 hsv = rgb2hsv(bg.rgb);

        gl_FragColor = vec4( hsv2rgb(vec3( 
                                              mod((hsv.x+u_hShift),360.0)
                                            , min(max(hsv.y+u_sShift,0.0),1.0)
                                            , min(max(hsv.z+u_lShift,0.0),1.0)))
                                            , bg.a );
        }
        `;

    this.vertexShader =
    `
        attribute vec2 a_position;
        attribute vec2 a_texCoord;
        varying vec2 v_texCoord;
        void main() {
        gl_Position = vec4(a_position * vec2(1,-1), 0, 1);
        v_texCoord = a_texCoord;
        }
    `;

    this.addShader(this.vertexShader, this.gl.VERTEX_SHADER);
    this.addShader(this.fragmentShader, this.gl.FRAGMENT_SHADER);

    //link the program
    this.gl.linkProgram(this.program);

    //throw exception if program doesn't link
    if (!this.gl.getProgramParameter(this.program, this.gl.LINK_STATUS)) {
        var lastError = this.gl.getProgramInfoLog(this.program);
        this.gl.deleteProgram(this.program);
        throw lastError;
    }

    this.u_image0 = this.gl.getUniformLocation(this.program, "u_image0");
    this.u_hShift = this.gl.getUniformLocation(this.program, "u_hShift");
    this.u_sShift = this.gl.getUniformLocation(this.program, "u_sShift");
    this.u_lShift = this.gl.getUniformLocation(this.program, "u_lShift");

    this.a_position = this.gl.getAttribLocation(this.program, "a_position");
    this.a_texCoord = this.gl.getAttribLocation(this.program, "a_texCoord");

    this.activate();
    this.gl.uniform1i(this.u_image0, 0); // texture unit image
  }

  update(hShift, sShift, lShift){
      this.activate();
      this.gl.uniform1f(this.u_hShift, hShift);
      this.gl.uniform1f(this.u_sShift, sShift);
      this.gl.uniform1f(this.u_lShift, lShift);
  }
}


/** WEBPACK FOOTER **
 ** ./src/cdl/style/glEffects/colorShift.js
 **/